import { createSlice } from "@reduxjs/toolkit";

const brandsSlice = createSlice({
    name: 'Brands',
    initialState: {
        loading: false,
        brands: [],
        resPerPage: 0,
        error: null,
    },
    reducers: {
        brandsRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        brandsSuccess(state, action) {
            return {
                ...state,
                loading: false,
                brands: action.payload.data,
                brandsCount: action.payload.count,
            }
        },
        brandsFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        },
        adminBrandsRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        adminBrandsSuccess(state, action) {
            return {
                ...state,
                loading: false,
                brands: action.payload.brands,
            }
        },
        adminBrandsFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        },
        clearError(state, action) {
            return {
                ...state,
                error: null
            }
        }
    }
});

const { actions, reducer } = brandsSlice;

export const {
    brandsRequest,
    brandsSuccess,
    brandsFail,
    adminBrandsFail,
    adminBrandsRequest,
    adminBrandsSuccess,
    clearError,
} = actions;

export default reducer;
